import { useQuery, UseQueryOptions } from 'react-query';
import { loadArchiveFolderStructure } from '~src/services/api/projectBuilder';
import { useProjectId } from '../useProjectId';

// A 401/403 here means the current user can never call this endpoint (e.g.
// no Project Builder / archive settings access) - retrying won't change
// that, so stop immediately. Otherwise cap retries at 3 total attempts
// instead of react-query's default (which keeps hammering the endpoint).
const shouldRetry = (err: any) => {
  const status = err?.response?.status;
  if (status === 401 || status === 403) return false;
  return true;
};

export const useProjectBuilder = (
  params?: { skip?: number; take?: number; sort?: string },
  options?: UseQueryOptions
) => {
  const projectId = useProjectId();

  return useQuery(
    ['projectBuilder', { projectId, ...params }],
    loadArchiveFolderStructure,
    {
      enabled: !!projectId,
      retry: (failureCount: number, err: any) => {
        if (!shouldRetry(err)) return false;
        return failureCount < 2;
      },
      ...options,
    }
  );
};
